export const PLATFORM_NAME = "BharatCredits";
export const DEVELOP_BY = "Adciasis Solutions Pvt. Ltd.";
